import { addDays } from 'date-fns';
import CalendarDayCell from './CalendarDayCell';
import { dayKey, gridWindow } from './useCalendarEvents';
import type { CalendarEventInstance } from './types';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

interface Props {
  month: Date;
  eventsByDay: Map<string, CalendarEventInstance[]>;
  onSelectEvent: (instance: CalendarEventInstance) => void;
  onSelectDay: (date: Date) => void;
  onCreateOnDay?: (date: Date) => void;
  onChipMouseEnter?: (instance: CalendarEventInstance, e: React.MouseEvent<HTMLElement>) => void;
  onChipMouseLeave?: () => void;
}

/** The 7×6 month grid. Pure presentation — data shaping lives in the hook. */
export default function CalendarGrid({
  month,
  eventsByDay,
  onSelectEvent,
  onSelectDay,
  onCreateOnDay,
  onChipMouseEnter,
  onChipMouseLeave,
}: Props) {
  const { gridStart } = gridWindow(month);
  const days = Array.from({ length: 42 }, (_, i) => addDays(gridStart, i));

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-2xl border border-flock-gray-200 bg-white shadow-sm">
      <div className="grid shrink-0 grid-cols-7 border-b border-flock-gray-200">
        {WEEKDAYS.map((d) => (
          <div
            key={d}
            className="px-2 py-2 text-center text-[11px] font-semibold uppercase tracking-wide text-flock-navy-400"
          >
            {d}
          </div>
        ))}
      </div>
      <div className="grid min-h-0 flex-1 grid-cols-7 grid-rows-6">
        {days.map((date) => (
          <CalendarDayCell
            key={dayKey(date)}
            date={date}
            month={month}
            instances={eventsByDay.get(dayKey(date)) ?? []}
            onSelectEvent={onSelectEvent}
            onSelectDay={onSelectDay}
            onCreateOnDay={onCreateOnDay}
            onChipMouseEnter={onChipMouseEnter}
            onChipMouseLeave={onChipMouseLeave}
          />
        ))}
      </div>
    </div>
  );
}
